import { FavoriteExamPrescription } from "../../models/medic/favorite-exam-prescription.model";

export class FavoriteExamPrescriptionStruct {
    public favoriteExamPrescription: FavoriteExamPrescription = new FavoriteExamPrescription();
    public listIdExam: number[] = [];
}